import { QUERY_PARAMS } from '@doda/common/src/constants/queryParams';

// 引き継ぎ不要なパラメータがある場合はこちらに随時追加する
export const REMOVE_PARAM_LIST = [
  'usrclk',
  'usrclk_searchList',
  'sid',
  'ss',
  'oldestDayWdtno',
];
export const DEFAULT_OPTION = {
  label: '条件で並べ替え',
  value: '0',
};
export const DEFAULT_ORDER_OPTIONS = [
  DEFAULT_OPTION,
  { label: '新着順', value: '1' },
  { label: '締切間近順', value: '2' },
];

/**
 * デフォルトで付与されるパラメータ
 */
export interface DefaultParamValues {
  pic?: string;
  ds?: string;
  so?: string;
  pf?: string;
  tp?: string;
}
export const NON_SEO_EFFECTIVE_PARAM = ['pic', 'ds', 'so', 'pf', 'tp'];

export const ORDER_OPTIONS = {
  newArrival: 'newArrival',
  deadline: 'deadline',
};

export const REMOVE_PARAM = {
  [QUERY_PARAMS.page]: undefined,
  [QUERY_PARAMS.prsrt]: undefined,
  [QUERY_PARAMS.usrclk]: undefined,
  [QUERY_PARAMS.usrclk_searchList]: undefined,
} as const satisfies Record<string, undefined>;

export const PATH_NAME_ACTION = '.action' as const;

// URLから抽出する対象のパラメータ
export const COND_QUERIES = [
  'oc',
  'ar',
  'pr',
  'ci',
  'wa',
  'rt',
  'st',
  'ind',
  'ha',
  'k',
  'kwc',
  'ni',
  'ne',
  'es',
  'op',
  'tp',
  'pf',
  'ds',
  'fid',
  'qc',
];

// カノニカルURLの２番目以降のパラメータに対応
// /-[key]__[value]/ か /-[key]__/[value]/ の形式
export const CARD_NAV_SUBSEQUENT_CANONICAL_PARAM_REGEX =
  /\/-([^/?]+__[^/?]+)|\/-([^/?]+__\/[^/?]+)\//;
